export const CRMWhiteIcon = ({ id }) => (
  <svg width="43" height="28" viewBox="0 0 43 28" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g id="Group 1261157990">
      <g id="Group 1261162730">
        <g id="Ellipse 4942">
          <ellipse cx="14.7227" cy="14" rx="13.978" ry="13.5" fill="#00D2D2" />
          <ellipse cx="14.7227" cy="14" rx="13.978" ry="13.5" fill="white" />
        </g>
        <g id="Union">
          <path
            d="M28.6663 13.045C28.705 13.5714 28.2564 13.9997 27.7075 13.9997L15.7175 13.9999C15.1686 13.9999 14.72 14.4283 14.7587 14.9546C14.9628 17.7359 16.0548 20.3968 17.8965 22.5642C19.9481 24.9785 22.8029 26.6311 25.9747 27.2404C29.1464 27.8498 32.4387 27.3781 35.2908 25.9058C38.1428 24.4335 40.378 22.0516 41.6155 19.1661C42.8531 16.2806 43.0164 13.0699 42.0777 10.0811C41.1389 7.09232 39.1562 4.51036 36.4673 2.77517C33.7785 1.03997 30.5498 0.258892 27.3315 0.565027C26.3701 0.656478 25.4274 0.84326 24.5171 1.11913C23.5836 1.39965 22.6838 1.77378 21.8326 2.23479C21.7817 2.26234 21.731 2.29021 21.6805 2.31838C23.8229 3.51305 25.6108 5.24262 26.8455 7.34205L26.8493 7.28466C26.8588 7.30054 26.8682 7.31645 26.8775 7.33238C27.9146 9.09574 28.5198 11.0492 28.6663 13.045Z"
            fill="white"
            fill-opacity="0.6"
          />
          <path
            d="M28.6663 13.045C28.705 13.5714 28.2564 13.9997 27.7075 13.9997L15.7175 13.9999C15.1686 13.9999 14.72 14.4283 14.7587 14.9546C14.9628 17.7359 16.0548 20.3968 17.8965 22.5642C19.9481 24.9785 22.8029 26.6311 25.9747 27.2404C29.1464 27.8498 32.4387 27.3781 35.2908 25.9058C38.1428 24.4335 40.378 22.0516 41.6155 19.1661C42.8531 16.2806 43.0164 13.0699 42.0777 10.0811C41.1389 7.09232 39.1562 4.51036 36.4673 2.77517C33.7785 1.03997 30.5498 0.258892 27.3315 0.565027C26.3701 0.656478 25.4274 0.84326 24.5171 1.11913C23.5836 1.39965 22.6838 1.77378 21.8326 2.23479C21.7817 2.26234 21.731 2.29021 21.6805 2.31838C23.8229 3.51305 25.6108 5.24262 26.8455 7.34205L26.8493 7.28466C26.8588 7.30054 26.8682 7.31645 26.8775 7.33238C27.9146 9.09574 28.5198 11.0492 28.6663 13.045Z"
            fill="url(#paint0_linear_3732_472)"
          />
        </g>
      </g>
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_3732_472"
        x1="38.8026"
        y1="8.60403"
        x2="14.9263"
        y2="17.2884"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#00A0A0" />
        <stop offset="1" stop-color="#00A0A0" stop-opacity="0.5" />
      </linearGradient>
    </defs>
  </svg>
);
